import { gql } from "@apollo/client";
import { AccountFragment } from "fragments/account";

export const BucketFileFragment = gql`
  fragment BucketFileFragment on BucketFile {
    id
    fileId
    description
    ext
    tags
    size
    status
    visibility
    metadata
    createdAt
    updatedAt
  }
`;

export const get = gql`
  query BucketFileGet($bucketId: String!, $fileId: String!) {
    viewer {
      id
      account {
        ...AccountFragment
        buckets {
          id
          get(bucketId: $bucketId) {
            id
            files {
              id
              get(fileId: $fileId) {
                ...BucketFileFragment
              }
            }
          }
        }
      }
    }
  }
  ${AccountFragment}
  ${BucketFileFragment}
`;

export const list = gql`
  query BucketFileList($bucketId: String!, $input: ListInput) {
    viewer {
      id
      account {
        id
        buckets {
          id
          get(bucketId: $bucketId) {
            id
            files {
              id
              list(input: $input) {
                id
                last
                items {
                  ...BucketFileFragment
                }
              }
            }
          }
        }
      }
    }
  }
  ${BucketFileFragment}
`;




export const create = gql`
  mutation BucketFileNew($bucketId: String!, $input: BucketFileInputCreate!) {
    viewer {
      account {
        buckets {
          get(bucketId: $bucketId) {
            files {
              create(input: $input) {
                form
                file {
                  ...BucketFileFragment
                }
              }
            }
          }
        }
      }
    }
  }
  ${BucketFileFragment}
`;



export const edit = gql`
  mutation BucketFileEdit(
    $bucketId: String!
    $fileId: String!
    $input: BucketFileInputUpdate!
  ) {
    viewer {
      account {
        buckets {
          get(bucketId: $bucketId) {
            files {
              get (fileId: $fileId) {
                update(input: $input) {
                  ...BucketFileFragment
                }
              }
            }
          }
        }
      }
    }
  }
  ${BucketFileFragment}
`;


export const remove = gql`
  mutation BucketFileRemove(
    $bucketId: String!
    $fileId: String!
  ) {
    viewer {
      account {
        buckets {
          get(bucketId: $bucketId) {
            files {
              get (fileId: $fileId) {
                remove
              }
            }
          }
        }
      }
    }
  }
`;




export const update = ({ bucketId }) => (cache) => {
  Object.keys(cache.data.data).forEach((key) => {
    if (key.includes(`${bucketId}/file/queries`)) {
      cache.data.delete(key);
    }
  });
};
